import { useEffect } from 'react';
import { getLocale } from '../locale';
import useSessionStorage from '../reactHooks/useSessionStorage';
import { LoadingStates } from '../request/constants';
import { isIos } from '../touchpoint';
import fetchLabels from './fetchLabels';
import { FETCHING_LABELS, getLabelsFromStorage } from './helpers';
import shouldShowCopyKeys from './showCopyKeys';
let isCleanupProcedureInitialized = false;
const useGetLabels = () => {
    const showLabelKeys = shouldShowCopyKeys();
    const [fetchingLabelState, setFetchingLabelState] = useSessionStorage(FETCHING_LABELS, false);
    const locale = getLocale();
    const isAemLabelsEnabled = process.env.IS_I18N_LABELS_ENABLED === 'enabled';
    const aemLabels = `labels_aem_${locale}`;
    const hybrisLabels = `labels.hybris.${locale}`;
    const eventName = isIos() ? 'visibilitychange' : 'beforeunload';
    useEffect(() => {
        const shouldFetchLabels = !window.sessionStorage.getItem(FETCHING_LABELS);
        const isAemLabelsStorage = !!window.sessionStorage.getItem(aemLabels);
        const isHybrisLabelsStorage = !!window.sessionStorage.getItem(hybrisLabels);
        const shouldFetchAemLabels = isAemLabelsEnabled && !isAemLabelsStorage;
        if (showLabelKeys) {
            setFetchingLabelState(LoadingStates.LoadedSuccess);
        }
        else if (shouldFetchLabels || (shouldFetchAemLabels && !isHybrisLabelsStorage)) {
            fetchLabels(setFetchingLabelState);
        }
    }, []);
    useEffect(() => {
        // True when other component started fetching labels
        const shouldWaitForLabelsFetch = sessionStorage.getItem(FETCHING_LABELS) !== LoadingStates.LoadedSuccess;
        if (!shouldWaitForLabelsFetch) {
            return () => { };
        }
        const interval = window.setInterval(() => {
            if (sessionStorage.getItem(FETCHING_LABELS) === LoadingStates.LoadedSuccess) {
                setFetchingLabelState(LoadingStates.LoadedSuccess);
                window.clearInterval(interval);
            }
        }, 250);
        return () => window.clearInterval(interval);
    }, []);
    // Needed to make working the switching between showKeys=true and normal mode
    // More details could be found in tests
    useEffect(() => {
        if (!isCleanupProcedureInitialized) {
            isCleanupProcedureInitialized = true;
            window.addEventListener(eventName, () => {
                window.sessionStorage.removeItem(FETCHING_LABELS);
            });
        }
    }, []);
    return {
        allLabels: getLabelsFromStorage(),
        isFetchingLabels: fetchingLabelState !== LoadingStates.LoadedSuccess,
        showLabelKeys,
    };
};
export default useGetLabels;
//# sourceMappingURL=useGetLabels.js.map